import React from "react"
import { Button, Menu, MenuItem, ListSubheader } from "@mui/material"
import { FACTOR_RULE_DISPLAY_TYPES } from "../constants"
import type { FactorRuleDisplayType } from "../types"

interface FactorRulesMenuProps {
  anchorEl: null | HTMLElement
  onOpen: (event: React.MouseEvent<HTMLButtonElement>) => void
  onClose: () => void
  onSelectType: (ruleType: FactorRuleDisplayType) => void
}

export default function FactorRulesMenu({ anchorEl, onOpen, onClose, onSelectType }: FactorRulesMenuProps) {
  return (
    <React.Fragment>
      <Button
        className="add-rule-button"
        variant="outlined"
        onClick={onOpen}
        color="primary"
      >
        Add Target
      </Button>
      <Menu
        id="add-factor-rule-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <ListSubheader component="div">
          Select target type
        </ListSubheader>
        <MenuItem onClick={() => onSelectType(FACTOR_RULE_DISPLAY_TYPES.EXPOSURE)}>Exposure</MenuItem>
        <MenuItem onClick={() => onSelectType(FACTOR_RULE_DISPLAY_TYPES.COMPOSITION)}>Composition</MenuItem>
      </Menu>
    </React.Fragment>
  )
}
